import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

export type Tag = {
    createdAt: string;
    deleted: boolean;
    deletedAt: string | null;
    id: number;
    name: string;
    userId: string | null;
};

export const fetchAvailableTags = withLogs(
    async (supabase: SupabaseClient<Database>, userId: string): Promise<Tag[]> => {
        const { data, error } = await supabase
            .from('activity_tags')
            .select('*')
            .eq('user_id', userId)
            .eq('deleted', false);

        if (error) {
            throw error;
        }

        return camelcaseKeys(data, { deep: true }) || [];
    },
    'fetchAvailableTags',
);

export type UpsertTagPayload = { tagId: number; userId: string; name: string };

export const upsertTag = withLogs(
    async (supabase: SupabaseClient<Database>, { tagId, userId, name }: UpsertTagPayload) => {
        const { data, error } = await supabase
            .from('activity_tags')
            .upsert({
                id: tagId > 0 ? tagId : undefined,
                name,
                user_id: userId,
            })
            .select()
            .maybeSingle();

        if (error) {
            throw error;
        }
        if (!data) {
            throw new Error('no data returned');
        }
        return camelcaseKeys(data);
    },
    'upsertTag',
);

export type DeleteTagPayload = { tagId: number; userId: string };

export const deleteTag = withLogs(async (supabase: SupabaseClient<Database>, { tagId, userId }: DeleteTagPayload) => {
    const { error } = await supabase
        .from('activity_tags')
        .update({ deleted: true })
        .eq('id', tagId)
        .eq('user_id', userId);

    if (error) {
        throw error;
    }
}, 'deleteTag');
